import { compare } from '../unknowns/compare';

export const getChangedItems = <T>(
  initArr: T[],
  currentArr: T[],
  identify: (el1: T, el2: T) => boolean,
  equalityCondition: (el1: T, el2?: T) => boolean = compare
): T[] =>
  currentArr.filter(
    el =>
      !equalityCondition(
        el,
        initArr.find(e => identify(el, e))
      )
  );
